import React, { useEffect } from "react";
import { RiCloseLargeLine } from "react-icons/ri";

const AddressInfo = ({ formData, handleInputChange, sideImg, handleClose, profileData, setProfileData }) => {

  useEffect(() => {
    setProfileData(formData)
  }, [])

  return (
    <div>
      <div className="flex justify-between items-center bg-white shadow-md p-4 fixed w-full z-50">
        <div className="flex items-center gap-3">
          <img className="cursor-pointer" onClick={handleClose} src={sideImg} width={"32px"} height={"32px"} alt={"sideImg"} />
          <h2 className="text-lg text-customBlackHeadColor font-SegoeUI font-semibold">
            Edit Address Information
          </h2>
        </div>
      </div>
      <div className="p-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-28">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Address
            </label>
            <input
              type="text"
              placeholder="Address"
              className="mt-1 block w-full border border-gray-300 h-12 rounded-md pl-2 bg-[#FAFAFA] shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              value={profileData.address1}
              onChange={(e) => handleInputChange("address1", e.target.value)}
            />
          </div>
          {/* <div>
            <label className="block text-sm font-medium text-gray-700">
              Address 2
            </label>
            <input
              type="text"
              placeholder="Address 2"
              className="mt-1 block w-full h-12 border border-gray-300 rounded-md pl-2 bg-[#FAFAFA] shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              value={profileData.address2}
              onChange={(e) => handleInputChange("address2", e.target.value)}
            />
          </div> */}
          <div>
            <label className="block text-sm font-medium text-gray-700">
              City
            </label>
            <input
              type="text"
              placeholder="City"
              className="mt-1 block w-full h-12 border border-gray-300 rounded-md pl-2 bg-[#FAFAFA] shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              value={profileData.city}
              onChange={(e) => handleInputChange("city", e.target.value)}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">
              State
            </label>
            <input
              type="text"
              placeholder="State"
              className="mt-1 block w-full h-12 border border-gray-300 rounded-md pl-2 bg-[#FAFAFA] shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              value={profileData.state}
              onChange={(e) => handleInputChange("state", e.target.value)}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Country
            </label>
            <input
              type="text"
              placeholder="Country"
              className="mt-1 block w-full h-12 border border-gray-300 rounded-md pl-2 bg-[#FAFAFA] shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              value={profileData.country}
              onChange={(e) => handleInputChange("country", e.target.value)}
            />
          </div>
          {/* <div>
            <label className="block text-sm font-medium text-gray-700">
              State
            </label>
            <input
              type="text"
              placeholder="State"
              className="mt-1 block w-full h-12 border border-gray-300 rounded-md pl-2 bg-[#FAFAFA] shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              value={profileData.state}
              onChange={(e) => handleInputChange("state", e.target.value)}
            />
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default AddressInfo;
